import { render } from "./GuideView.vue?vue&type=template&id=8218eff8&scoped=true"
import script from "./GuideView.vue?vue&type=script&lang=js"
export * from "./GuideView.vue?vue&type=script&lang=js"

import "./GuideView.vue?vue&type=style&index=0&id=8218eff8&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8218eff8"]])

export default __exports__